

import { Component, Vue, VModel, Prop } from "vue-property-decorator";

@Component
export default class IBSpinnerLoading extends Vue {

	@VModel({ type: Boolean })
	active!: boolean

	@Prop({ type: Number, default: 4 })
	readonly width!: number

	@Prop({ type: Number, default: 48 })
	readonly size!: number

	@Prop({ type: [ Number, String ], default: '50%' })
	readonly top!: number | string

	@Prop({ type: [ Number, String ], default: '50%' })
	readonly left!: number | string

	@Prop(Boolean)
	readonly fill!: boolean

	@Prop(Boolean)
	readonly primary!: boolean

}

